<template>
    <div class="grid grid-cols-4 gap-2 lg:grid-cols-8">
        <div
            class="flex cursor-pointer flex-col items-center justify-center rounded-md bg-green-bg p-2 text-black-78 hover:bg-green-10"
            v-for="icon in icons"
            :key="icon"
            @click="copyToClipboard(icon)"
        >
            <v-icon :icon="icon" size="5" class="mb-2"></v-icon>
            <p class="text-center text-sm">{{ icon }}</p>
        </div>
        <div
            class="notification z-10 bg-black-78 text-[12px] font-medium text-white"
            :class="{ active: showNotification }"
        >
            <span class="font-mono text-salmon">{{ copiedSlug }}</span> copied
            to clipboard
        </div>
    </div>
</template>

<style>
.notification {
    position: fixed;
    bottom: 20px;
    left: 50%;
    transform: translateX(-50%);
    padding: 10px 20px;
    border-radius: 5px;
    opacity: 0;
    transition: opacity 0.3s ease-in-out;
}

.notification.active {
    opacity: 1;
}
</style>

<script>
export default {
    name: "DesignSystemIcons",
    data() {
        return {
            icons: [
                "n24",
                "n24-beta",
                "calendar-date",
                "calendar-dot",
                "calendar-dot-mono",
                "rocket",
                "hand-wave",
                "search-desktop",
                "file-user",
                "shopping-bag",
                "map-pin",
                "buy-house",
                "house",
                "banknotes",
                "loupe-check",
                "loupe-world",
                "loupe-graph",
                "loupe-list",
                "map",
                "houses",
                "user-plus",
                "users-plus",
                "messages",
                "document-dollar",
                "user",
                "arrow-down",
                "big-arrow-down",
                "big-arrow-up",
                "arrow-right",
                "arrow-left",
                "info",
                "email-drawer",
                "phone",
                "megaphone",
                "phone-verify",
                "chevron-left",
                "check",
                "follow",
                "key",
                "n24-mono",
                "newsletter",
                "instagram",
                "facebook",
                "linkedin",
                "square-size",
                "rooms",
                "angle-right",
                "angle-left",
                "chevron-down",
                "loupe",
                "apartment",
                "land",
                "room",
                "filter",
                "sort",
                "heart",
                "heart-solid",
                "euro",
                "account-circle",
                "reset",
                "reload",
                "x-circle",
                "close",
                "chair",
                "floor",
                "loupe-box",
                "fireplace",
                "energy",
                "percent",
                "arrow-right-inside-box",
                "missing-brain",
                "loupe-again",
                "dong",
                "check-circle",
                "add-listing",
                "save",
                "add-home-work",
                "home",
                "home-solid",
                "circle-add",
                "circle-add-solid",
                "upcoming",
                "house-work",
                "door",
                "mountain",
                "bed",
                "shower",
                "stairs",
                "home-arrows-circle",
                "overview",
                "balcony",
                "mode-fan",
                "countertops",
                "elevator",
                "basement",
                "doorbell",
                "router",
                "pets",
                "garage",
                "no-crash",
                "garage-home",
                "house-dots",
                "visibility",
                "visibility-off",
                "circle-check",
                "handyman",
                "calendar-arrow",
                "gas-meter",
                "energy-leaf",
                "free-cancellation",
                "water-voc",
                "calendar-dots",
                "gallery",
                "valve",
                "oil-barrel",
                "adjust",
                "key-visualizer",
                "bolt",
                "add-card",
                "location-away",
                "payments",
                "certificate",
                "envelope",
                "envelope-checked",
                "envelope-dot",
                "id",
                "upload",
                "jump",
                "apple",
                "google",
                "pin-house-location",
                "graph-leaf",
                "image-photo-add",
                "house-check",
                "house-dots",
                "user-chat",
                "tag",
                "size",
                "list-clock",
                "house-user",
                "build-circle",
                "home-repair-service",
                "contract-edit",
                "car",
                "inventory",
                "fire",
                "energy-card",
                "radio-unchecked",
                "radio-checked",
                "checkbox",
                "window",
                "roofing",
                "roller",
                "water-heater",
                "faucet",
                "electric-meter",
                "reset-wrench",
                "deceased",
                "wc",
                "deck",
                "heat-pump-balance",
                "key-visualizer",
                "data-saver-on",
                "public",
                "nature",
                "oil-barrel",
                "forrest",
                "propane",
                "solar-power",
                "heat-pump",
                "engineering",
                "design-services",
                "calendar-check",
                "cancel",
                "voice",
                "shield",
                "question-mark",
                "warehouse",
                "no-crash",
                "local-parking",
                "format-overline",
                "steppers",
                "clock",
                "bed-single",
                "business",
                "timer",
                "chart-data",
                "power-drill",
                "bookmark-added",
                "ambient-screen",
                "find-in-page",
                "drag-handle",
                "partial",
                "water-pump",
                "history-edu",
                "title",
                "article",
                "notes",
                "add-photo",
                "folder",
                "images-mode",
                "art-track",
                "delete",
                "arhitecture",
                "energy-program-time-used",
                "add-to-photos",
                "logout",
                "settings-gear-profile",
                "back",
                "new-house",
                "new-apartment",
                "draft",
                "pause",
                "settings-account-box",
                "location-home",
                "connect-without-contact",
                "holiday-village",
                "saved-search",
                "heart-check",
                "clinical-notes",
                "trash",
                "send",
                "show-number",
                "captive-portal",
                "business-chip",
                "work",
                "contact-emergency",
                "call",
                "outgoing-mail",
                "email",
                "content-copy",
                "hourglass",
                "preview",
                "play",
                "lock",
                "delete-history",
                "resume",
                "edit",
                "hourglass",
                "nest-clock-farsight-analog",
                "update",
                "mark-email-unread",
                "contract-delete",
                "plus",
                "saved-search",
                "brand-awareness",
                "password",
                "replay",
            ],
            showNotification: false,
            copiedSlug: "",
        };
    },
    methods: {
        copyToClipboard(icon) {
            const textArea = document.createElement("textarea");
            textArea.value = '<v-icon icon="' + icon + '"></v-icon>';
            document.body.appendChild(textArea);
            textArea.select();
            document.execCommand("copy");
            document.body.removeChild(textArea);

            this.copiedSlug = '<v-icon icon="' + icon + '"></v-icon>';
            this.showNotification = true;
            setTimeout(() => {
                this.showNotification = false;
            }, 3000);
        },
    },
};
</script>
